<template>
  <!--PORTFOLIO MODAL 2 - BANCO DE NIMBLY PROJECT -->
  <div
    class="portfolio-modal modal fade"
    id="portfolioModal2"
    tabindex="-1"
    role="dialog"
    aria-labelledby="portfolioModal2Label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <button
          class="close btn btn-outline-light"
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="fas fa-times"></i></span>
        </button>
        <div class="modal-body text-center">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-8">
                <!-- Portfolio Modal - Title-->
                <h2
                  class="portfolio-modal-title text-secondary text-uppercase mb-5"
                  id="portfolioModal2Label"
                >
                  Banco De Nimbly Web Application
                </h2>
                <!-- Portfolio Modal - Image-->
                <img
                  class="img-fluid rounded mb-5"
                  src="../../assets/banco-de-nimbly.png"
                  alt=""
                />
                <!-- Portfolio Modal - Text-->
                <p class="mb-5">
                  This web application was created by me as an final
                  requirements for my Enterprise Java 2 class. I have used
                  <a href="https://materializecss.com/">materialize</a> css,
                  struts-2, and hibernate in developing this application . Click
                  this
                  <a
                    href="https://github.com/nimbly-dev/school-projects/tree/master/FINALS-CSELEC09-SEG31-SAQUILAYAN-ALTHEO_BANK-ACCOUNT"
                    >link</a
                  >
                  to redirect to the source code.
                </p>
                <button class="btn btn-primary" data-bs-dismiss="modal">
                  <i class="fas fa-times fa-fw"></i>
                  Close Window
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "portfolio-modal-two",
};
</script>

<style>
</style>